export const loadingConfig = {
    maxLoadingTimeout: 30000,
    timeoutToClose: 800
}
